import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorAwareAlertBox } from './ErrorAwareAlertBox';
const ErrorBoundaryWrapper = ({ children, noun }) => (React.createElement(ErrorBoundary, { FallbackComponent: (props) => ErrorAwareAlertBox({ error: props.error, noun }) }, children));
export default ErrorBoundaryWrapper;
